<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Getting the Most Out of <i>The Messiah</i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table border="" style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:7px;">
<col style="width:60%;padding:7px;"/>
<col style="width:40%;padding:7px;"/>
</colgroup>
<tbody>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><a href="#/chap1"><b>1 His Name Is Wonderful<br/><i>Messiah’s Character</i></b></a></p></td>
<td style="padding:7px;vertical-align:top;vertical-align:bottom;"><p class="SOM_chap1"><a href="#/chap1">Isaiah 9:6-7</a></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><b>2 The Virgin Will Be with Child<br/><i>Messiah’s Birth</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap2" title="Link target outside of Sample">Isaiah 7:1-16; Matthew 1:18-25</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><b>3 The Lame Will Walk<br/><i>Messiah’s Miracles</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap3" title="Link target outside of Sample">Isaiah 35:3-6; Matthew 11:1-6</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><b>4 Why Have You Forsaken Me?<br/><i>Messiah’s Death</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap4" title="Link target outside of Sample">Psalm 22:1-21</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><b>5 Pierced for Our Transgressions<br/><i>Messiah’s Sacrifice</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap5" title="Link target outside of Sample">Isaiah 53:1-10</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><b>6 The Path of Life<br/><i>Messiah’s Resurrection</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap6" title="Link target outside of Sample">Psalm 16:7-11; Acts 2:22-32</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><b>7 Lift Up Your Heads<br/><i>Messiah’s Exaltation</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap7" title="Link target outside of Sample">Psalm 24</span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><b>8 The Clouds of Heaven<br/><i>Messiah’s Return</i></b></span></p></td>
<td style="padding:7px;vertical-align:bottom;"><p class="SOM_chap1"><span href="#/chap8" title="Link target outside of Sample">Daniel 7:9-14; Revelation 19:1-16</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">LifeGuide® in Depth Bible Studies</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?36be27ac